import { render, staticRenderFns } from "./StarVideo_v2.vue?vue&type=template&id=0e90ec42&"
import script from "./StarVideo_v2.vue?vue&type=script&lang=js&"
export * from "./StarVideo_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StarVideo_v2.vue"
export default component.exports